module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/related/en/1-f2922ece27e77d4ce1022ff94de0d2dd.jpg";